import { FenceIcon } from './FenceIcon';

/**
 * author: Michael Irigoyen
 * id CAFE2FF6-D1D5-4411-9AA1-33C5076F0E4E
 * name fence
 * version: 6.1.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/fence.svg
 * tags
 * - Home Automation 
 * - Agriculture 
 */
export const RailwayIcon = FenceIcon;
export default RailwayIcon